import Cart from 'JS/classes/cart/Cart';

(() => {
    new Cart('#cart-page');
})();
